// extracted by mini-css-extract-plugin
module.exports = {"error":"dd31006766--error--l9jko"};